var map = {
  "./video-engine/stores/video-call-ui-store.js": [
    "./src/SharedWeb/scripts/apps/video-engine/stores/video-call-ui-store.js"
  ],
  "./video-engine/stores/participant-tiles-store.js": [
    "./src/SharedWeb/scripts/apps/video-engine/stores/participant-tiles-store.js",
    "src_SharedWeb_scripts_apps_video-engine_stores_participant-tiles-store_js"
  ],
  "./conversations/stores/conversation-store": [
    "./src/SharedWeb/scripts/apps/conversations/stores/conversation-store.js"
  ],
  "./conversations/stores/message-store": [
    "./src/SharedWeb/scripts/apps/conversations/stores/message-store.js"
  ],
  "./video-engine/stores/meeting-chat-store.js": [
    "./src/SharedWeb/scripts/apps/video-engine/stores/meeting-chat-store.js",
    "src_SharedWeb_scripts_apps_video-engine_stores_meeting-chat-store_js"
  ],
  "./conversations/stores/conversation-store.js": [
    "./src/SharedWeb/scripts/apps/conversations/stores/conversation-store.js"
  ],
  "./conversations/stores/message-store.js": [
    "./src/SharedWeb/scripts/apps/conversations/stores/message-store.js"
  ],
  "./video-engine/stores/livestream-store": [
    "./src/SharedWeb/scripts/apps/video-engine/stores/livestream-store.js"
  ],
  "./video-engine/stores/participant-tiles-store": [
    "./src/SharedWeb/scripts/apps/video-engine/stores/participant-tiles-store.js",
    "src_SharedWeb_scripts_apps_video-engine_stores_participant-tiles-store_js"
  ],
  "./video-engine/stores/video-call-store.js": [
    "./src/SharedWeb/scripts/apps/video-engine/stores/video-call-store.js"
  ],
  "./video-engine/stores/livekit-store": [
    "./src/SharedWeb/scripts/apps/video-engine/stores/livekit-store.js"
  ],
  "./video-engine/stores/video-call-store": [
    "./src/SharedWeb/scripts/apps/video-engine/stores/video-call-store.js"
  ],
  "./video-engine/stores/conversation-call-store": [
    "./src/SharedWeb/scripts/apps/video-engine/stores/conversation-call-store.js"
  ],
  "./video-engine/stores/conversation-call-store.js": [
    "./src/SharedWeb/scripts/apps/video-engine/stores/conversation-call-store.js"
  ],
  "./meta-verse/engine/stores/meta-verse-store": [
    "./src/SharedWeb/scripts/apps/meta-verse/engine/stores/meta-verse-store.js",
    "src_SharedWeb_scripts_apps_meta-verse_engine_stores_meta-verse-store_js"
  ],
  "./video-engine/stores/livekit-store.js": [
    "./src/SharedWeb/scripts/apps/video-engine/stores/livekit-store.js"
  ],
  "./video-engine/stores/meeting-chat-store": [
    "./src/SharedWeb/scripts/apps/video-engine/stores/meeting-chat-store.js",
    "src_SharedWeb_scripts_apps_video-engine_stores_meeting-chat-store_js"
  ],
  "./video-engine/stores/video-call-ui-store": [
    "./src/SharedWeb/scripts/apps/video-engine/stores/video-call-ui-store.js"
  ],
  "./video-engine/stores/livestream-store.js": [
    "./src/SharedWeb/scripts/apps/video-engine/stores/livestream-store.js"
  ],
  "./meta-verse/engine/stores/meta-verse-store.js": [
    "./src/SharedWeb/scripts/apps/meta-verse/engine/stores/meta-verse-store.js",
    "src_SharedWeb_scripts_apps_meta-verse_engine_stores_meta-verse-store_js"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
    return __webpack_require__(id);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "./src/SharedWeb/scripts/apps lazy recursive ^\\.\\/.*\\/stores\\/.*$ referencedExports: ";
module.exports = __rspack_async_context;
